import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import useApp from "../../../utils/useApp";
import { useLocation } from "react-router-dom";
import { currentUrl } from "../../../App";
import { fetchFields } from "../../../services/httpClient";
import Fields from "./Fields";

interface OrgFieldsState {
  setOrgToSave: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const OrgFields = ({
  setOrgToSave,
  setShowToast,
  setToastText,
  setToastBody,
}: OrgFieldsState) => {
  const { auth, showMenu }: any = useApp();
  const location = useLocation();
  currentUrl.value = location.pathname;
  const [errMsg, setErrMsg] = useState("");
  const [fields, setFields] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);

  useEffect(() => {
    getFields();
  }, [auth?.profile]);

  const getFields = () => {
    fetchFields()
      .then((res: any) => {
        var fields = res[0].data;
        fields = fields.map((f: any) => ({ ...f, name: f.label }));

        setFields(fields);
        setIsLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading ? (
        <Container className={showMenu ? "lg div-main-menu" : "lg div-main"}>
          <Button size="sm" className="spinner-button spinner-button-main">
            <Spinner animation="border" style={{ color: "#F6893D" }} />
          </Button>
        </Container>
      ) : (
        <>
          <p className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">
            {errMsg}
          </p>
          <Row className="mb-4">
            <Col xs={9}>
              <h4 className="app-header-text">Custom Fields</h4>
            </Col>
            <Col xs={3} className="d-flex justify-content-end">
              <Button
                className="app-primary-color button"
                onClick={() => setShowAdd(true)}
              >
                Create Custom Field
              </Button>
            </Col>
          </Row>
          <Fields
            fields={fields}
            getFields={getFields}
            setOrgToSave={setOrgToSave}
            setErrMessage={setErrMsg}
            setShowToast={setShowToast}
            setToastText={setToastText}
            setToastBody={setToastBody}
            showAddField={showAdd}
            setShowAddField={setShowAdd}
          />
        </>
      )}
    </>
  );
};

export default React.memo(OrgFields);
